"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactHelmet = _interopRequireDefault(require("react-helmet"));

function HtmlHead(_ref) {
  var htmlHead = _ref.htmlHead;

  if (htmlHead) {
    var _htmlHead$meta = htmlHead.meta,
        meta = _htmlHead$meta === void 0 ? [] : _htmlHead$meta,
        title = htmlHead.title,
        canonical = htmlHead.canonical;
    return /*#__PURE__*/_react.default.createElement(_reactHelmet.default, null, title ? /*#__PURE__*/_react.default.createElement("title", null, title) : null, meta.map(function (m, idx) {
      return /*#__PURE__*/_react.default.createElement("meta", {
        key: idx,
        name: m.name,
        content: m.content
      });
    }), canonical ? /*#__PURE__*/_react.default.createElement("link", {
      rel: "canonical",
      href: canonical
    }) : null);
  }

  return null;
}

process.env.NODE_ENV !== "production" ? HtmlHead.propTypes = {
  htmlHead: _propTypes.default.shape({
    canonical: _propTypes.default.string,
    meta: _propTypes.default.arrayOf(_propTypes.default.shape({
      content: _propTypes.default.string,
      name: _propTypes.default.string
    })),
    title: _propTypes.default.string
  }).isRequired
} : void 0;
var _default = HtmlHead;
exports.default = _default;